import _implicitStylesheets from "./notifications.css";
import _implicitScopedStylesheets from "./notifications.scoped.css?scoped=true";
import _wdsMessageBox from "wds/messageBox";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "notifications-layout": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "notifications-container": true
  },
  key: 1
};
const stc2 = {
  "message-box-container": true
};
const stc3 = {
  "data-testid": "notification-message"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, b: api_bind, c: api_custom_element, h: api_element, i: api_iterator} = $api;
  const {_m0, _m1} = $ctx;
  return [$cmp.hasNotifications ? api_element("div", stc0, [api_element("div", stc1, api_iterator($cmp.notifications, function (item) {
    return api_element("div", {
      classMap: stc2,
      key: api_key(2, item.iteratorKey)
    }, [api_custom_element("wds-message-box", _wdsMessageBox, {
      attrs: stc3,
      props: {
        "type": item.type,
        "title": item.title,
        "message": item.message,
        "icon": item.icon,
        "iteratorKey": item.iteratorKey
      },
      key: 3,
      on: {
        "close": _m0 || ($ctx._m0 = api_bind($cmp.handleCloseNotification)),
        "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleInputKey))
      }
    })]);
  }))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4e7mfh6nig5";
tmpl.legacyStylesheetToken = "undefined-_notifications";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
